import { DescriptionOutlined } from '@mui/icons-material'
import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import { AccountDocumentDto } from '../../../interactors/gen/backendClient'
/* import { EditDocumentModal } from './EditDocumentModal' */
import { blueSky, theme } from '../../theme'
import { DeleteDocumentModal } from './DeleteDocumentModal'
import { useAccountsStore } from '../../../store/AccountsStore'
import {
  fullName,
  getColorForAccountDocumentType,
  getReadableAccountDocumentType,
} from '../../../domain/Account/AccountDisplay'
import { DisplayChipLikeTextField } from '../../common/DisplayChipLikeTextField'
import { getAccountDocumentsSrc } from '../../../utils/S3-links'

interface DocumentItemProps {
  document: AccountDocumentDto
  accountId: string
  setDocumentsList?: React.Dispatch<React.SetStateAction<AccountDocumentDto[]>>
  disabled?: boolean
}

export const DocumentItem: React.FC<DocumentItemProps> = ({
  document,
  accountId,
  setDocumentsList,
  disabled = false,
}) => {
  const sxField = { cursor: 'disabled', input: { cursor: 'not-allowed' } }
  const accountsStore = useAccountsStore()
  const members = accountsStore.members
  const member = members.find((m) => m.id === document.uploadedBy)

  return (
    <Box
      sx={{
        py: 1,
        borderBottom: '1px solid rgba(122, 129, 151, 0.16)',
        '&:last-of-type': { borderBottom: 'none' },
        '& .MuiOutlinedInput-root': { backgroundColor: 'transparent', borderRadius: 2 },
        '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(122, 129, 151, 0.18)' },
        '& .MuiInputLabel-root': { color: '#7A8197', fontWeight: 700 },
        '& .MuiOutlinedInput-input': { py: 1.1 },
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={1.8} sm={0.8}>
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <DescriptionOutlined sx={{ width: 34, height: 34, color: blueSky }} />
          </Box>
        </Grid>
        <Grid item xs={10.2} sm={5.6} md={3}>
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <DisplayChipLikeTextField
              label="Nom du document"
              value={document.type === 'others' ? document.name! : getReadableAccountDocumentType(document.type) || ''}
              fullWidth
              documentPage
              color={getColorForAccountDocumentType(document.type) || blueSky}
              compact
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={5.6} md={3}>
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            {document.obtainedDate ? (
              <TextField
                label="Date d'obtention/d'actualisation"
                type="text"
                fullWidth
                value={new Date(document.obtainedDate).toLocaleDateString()}
                sx={sxField}
                size="small"
                inputProps={{ readOnly: true }}
              />
            ) : (
              <TextField
                label="Libellé"
                type="text"
                fullWidth
                value={document.reference}
                sx={sxField}
                size="small"
                inputProps={{ readOnly: true }}
              />
            )}
          </Box>
        </Grid>
        <Grid item xs={12} sm={5} md={2.2}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="left"
            justifyContent="center"
            height="100%"
            sx={{ color: theme.palette.grey[500] }}
          >
            <Box
              display="flex"
              flexDirection={{ xs: 'row', sm: 'column' }}
              justifyContent={{ xs: 'space-between', sm: 'center' }}
            >
              <Typography variant="body2" fontSize={14}>
                Mis en ligne le {new Date(document.uploadedAt).toLocaleDateString()}
              </Typography>
              {member && (
                <Typography variant="body2" fontSize={14}>
                  Par {fullName(member)}
                </Typography>
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6} sm={5.5} md={2.2}>
          <Box display="flex" flexDirection="column" alignItems="left" justifyContent="center" height="100%">
            <Button
              variant="outlined"
              href={getAccountDocumentsSrc(document.documentKey)}
              target="_blank"
              sx={{
                textTransform: 'none',
                borderRadius: '999px',
                minHeight: 36,
                px: 2.25,
                fontWeight: 800,
                backgroundColor: 'rgba(255, 255, 255, 0.72)',
                borderColor: 'rgba(122, 129, 151, 0.24)',
                color: theme.palette.primary.main,
                '&:hover': { backgroundColor: 'white', borderColor: 'rgba(122, 129, 151, 0.35)' },
              }}
            >
              Consulter
            </Button>
          </Box>
        </Grid>
        {/* Commented as backend is not ready yet */}
        {/* <Grid item xs={3} sm={1.5} md={0.8}>
          <Box display="flex" justifyContent="center" alignItems="center" height="100%" maxWidth="100%">
            <EditDocumentModal document={document} />
          </Box>
        </Grid> */}
        <Grid item xs={6} sm={1.5} md={0.8}>
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <DeleteDocumentModal
              documentId={document.id}
              accountId={accountId}
              setDocumentsList={setDocumentsList}
              disabled={disabled}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}
